export const getFuelTypeLabelSelected = ({fuelOptions, value}) => {
  const valueSet = new Set(value)

  return fuelOptions
    .filter(item => valueSet.has(item.id))
    .map(item => item.label)
    .join(', ')
}
